import { FieldConfig as UiFieldConfig, HiddenConfig } from '@qfa/forms';
import { LocationFormValues } from '../types';
import { useMemo } from 'react';
import { RecursivePartial } from 'types';
import { useForm } from 'kineticUtils';

const staticFields: UiFieldConfig[] = [
  HiddenConfig({ id: 'id', name: 'id', required: false }),
  HiddenConfig({ id: 'geometry', name: 'geometry', required: false }),
  HiddenConfig({ id: 'details', name: 'details', required: false }),
];

export const useLocationFormFields = ({
  initialData,
  hasPrivilege,
}: {
  initialData: LocationFormValues;
  hasPrivilege: boolean;
}) => {
  const form = useForm<RecursivePartial<LocationFormValues>>({
    fields: staticFields,
    defaultValues: initialData,
    readOnly: !hasPrivilege,
  });

  const {
    props: formProps,
    values: [values, setValues],
    errors: [hasErrors, errorMessages],
    dirty: [isDirty, dirtyFields, setDirtyFields],
    isSaveDisabled,
  } = form;

  const isSaveButtonDisabled = useMemo(() => {
    return isSaveDisabled || !hasPrivilege;
  }, [hasPrivilege, isSaveDisabled]);

  const returnData = useMemo(
    () => ({
      errorMessages,
      isDirty,
      dirtyFields,
      formProps,
      setDirtyFields,
      valuesProps: {
        values,
        setValues,
      },
      hasErrors,
      saveButtonProps: {
        isSaveDisabled: isSaveButtonDisabled,
      },
    }),
    [
      errorMessages,
      isDirty,
      dirtyFields,
      formProps,
      setDirtyFields,
      values,
      setValues,
      hasErrors,
      isSaveButtonDisabled,
    ]
  );

  return returnData;
};
